import { render, staticRenderFns } from "./Sudo.vue?vue&type=template&id=3a03f12d&"
import script from "./Sudo.vue?vue&type=script&lang=js&"
export * from "./Sudo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports